import axios, { AxiosPromise } from 'axios';
import config from '@/config';
import { urlParamBuilder } from '@/helpers/urlParamBuilder';
import { RequestStatusEnum } from '@/modules/analysis/models/requestStatusEnum';
import { AnalysisRequest, ChatMessage, ResultFile } from '@/modules/analysis/models/analysisRequest';

const resourceEndpoint = `${config.api.url}${config.api.privateEndpointsPrefix}${config.api.endpoints.analysisRequest}`;

export function create(analysisRequest: AnalysisRequest): AxiosPromise<void> {
  const cleanedRequest = analysisRequest;

  cleanedRequest.sampleBatches.forEach((batch) => {
    batch.analyzes.gammaSpecRnValue = batch.analyzes.gammaSpecRnValue
      .filter((item) => item.isActive)
      .map((item) => {
        return {
          label: item.label,
          value: item.value,
          detectionMode: item.detectionMode,
          detectionUnit: item.detectionUnit
        };
      });
  });

  return axios.post(
    resourceEndpoint,
    { analysisRequest: cleanedRequest },
    {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  );
}

export function read(id: string): AxiosPromise<AnalysisRequest> {
  return axios.get(`${resourceEndpoint}/${id}`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function fetchAll(param?: { status?: string; offset?: string }): AxiosPromise<AnalysisRequest[]> {
  const urlParam = urlParamBuilder(param);

  return axios.get(`${resourceEndpoint}/all?${urlParam}`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function updateStatus(id: string, statusBody: { status: RequestStatusEnum }): AxiosPromise<void> {
  return axios.patch(
    `${resourceEndpoint}/${id}/status`,
    { status: statusBody },
    {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  );
}

export function createMessage(id: string, chatMessage: { content: string }): AxiosPromise<void> {
  return axios.post(
    `${resourceEndpoint}/${id}/chat-messages`,
    { chatMessage },
    {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  );
}

export function getChatMessages(id: string): AxiosPromise<ChatMessage[]> {
  return axios.get(`${resourceEndpoint}/${id}/chat-messages`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function getResultFiles(id: string): AxiosPromise<ResultFile[]> {
  return axios.get(`${resourceEndpoint}/${id}/result-files`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function updateLaboratoryName(id: string, laboratoryNameBody: string): AxiosPromise<void> {
  return axios.patch(
    `${resourceEndpoint}/${id}/laboratory-name`,
    { laboratoryName: laboratoryNameBody },
    {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  );
}
